export default function DealerCustomerPage() {
    return (
        <div className="bg-white rounded-2xl shadow p-6">
            <h2 className="text-lg font-semibold mb-4">Dealer Customers</h2>
            <p className="text-sm text-gray-600">
                Manage and view your customers here.
            </p>
        </div>
    );
}
